export const unfinishedCallStorageKey = 'unfinishedCall';

export const pendingCallsStorageKey = 'pendingCallHistory';
